<template>
    <div ref="dashboardContents" class="dashboard-contents">
        <div ref="dashboardTit" class="dashboard-tit border-bottom py-20 min-h-120px d-flex align-center">
            <v-container class="container--x-large">
                <v-row v-if="tit" align="center" class="">
                    <v-col>
                        <h3 class="tit">
                            {{ tit }}
                        </h3>
                    </v-col>
                    <v-col v-if="topBtn" cols="12" md="auto">
                        <slot name="topBtn" />
                    </v-col>
                </v-row>
                <slot v-else name="tit" />
            </v-container>
        </div>

        <v-sheet class="pb-40 pb-lg-60 pt-160 pt-lg-180" :class="{ 'dashboard-contents__full-height': fullHeight }">
            <v-container class="container--x-large">
                <slot name="contents" />
            </v-container>
        </v-sheet>
    </div>
</template>

<script>
export default {
    props: {
        tit: { type: String, default: "" },
        topBtn: { type: Boolean, default: false },
        fullHeight: { type: Boolean, default: false },
    },
    data() {
        return {
        };
    },
    mounted() {
        this.getDashboardContentsWidth(); // 초기 실행
        window.addEventListener('resize', this.getDashboardContentsWidth); // 윈도우 창 크기 변경 감지
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getDashboardContentsWidth); // 컴포넌트 파괴 시 리스너 제거
    },
    methods: {
        getDashboardContentsWidth() {
            const dashboardContents = this.$refs.dashboardContents;
            const dashboardTit = this.$refs.dashboardTit;
            const dashboardContentsWidth = dashboardContents.clientWidth;
            dashboardTit.style.maxWidth = dashboardContentsWidth + 'px';
        }
    }
};
</script>

<style lang="scss" scoped>
.dashboard-contents{
    width: 100%;
    &,
    &__full-height{
        min-height: calc(100vh - 48px);
    }
    &__full-height>.container{
        min-height: calc(100vh - 248px);
        display: flex;
        flex-direction: column;
    }
}
.dashboard-tit{
    position: fixed;
    top: 48px;
    right: 0;
    width: 100%;
    background-color: #fff !important;
    z-index: 9;
    transition: 0.25s ease-out;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .dashboard-contents{
        &__full-height>.container{
            min-height: calc(100vh - 288px);
        }
    }
}
@media (min-width:1200px){
}

</style>
